import React, { useState, useRef, useEffect } from 'react';
import './SettingsMenu.css';

const SettingsMenu = ({ 
  selectedHouseId, 
  houses, 
  onHouseToggle, 
  onLogout,
  onNotificationToggle,
  notificationEnabled
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleHouseToggle = () => {
    if (onHouseToggle) {
      onHouseToggle();
    }
    setIsOpen(false);
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
    setIsOpen(false);
  };

  const handleNotificationToggle = () => {
    if (onNotificationToggle) {
      onNotificationToggle();
    }
    setIsOpen(false);
  };

  const selectedHouse = houses.find(h => h.id === selectedHouseId);
  const canToggleHouse = houses.length > 1;

  return (
    <div className="settings-menu-container" ref={menuRef}>
      <button
        className="settings-menu-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Settings"
        title="Settings"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="1"/>
          <circle cx="12" cy="5" r="1"/>
          <circle cx="12" cy="19" r="1"/>
          <circle cx="5" cy="12" r="1"/>
          <circle cx="19" cy="12" r="1"/>
          <circle cx="5.64" cy="5.64" r="1"/>
          <circle cx="18.36" cy="5.64" r="1"/>
          <circle cx="5.64" cy="18.36" r="1"/>
          <circle cx="18.36" cy="18.36" r="1"/>
        </svg>
      </button>

      {isOpen && (
        <div className="settings-menu-dropdown">
          <div className="settings-menu-header">
            <span>Settings</span>
          </div>
          
          <div className="settings-menu-divider"></div>

          {/* House Toggle */}
          <button
            className={`settings-menu-item ${!canToggleHouse ? 'disabled' : ''}`}
            onClick={handleHouseToggle}
            disabled={!canToggleHouse}
            title={canToggleHouse ? `Switch house (currently: ${selectedHouse?.name || 'None'})` : 'Only one house available'}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            <span>Switch House</span>
            {canToggleHouse && selectedHouse && (
              <span className="settings-menu-item-value">{selectedHouse.name}</span>
            )}
          </button>

          <div className="settings-menu-divider"></div>

          {/* Notifications Toggle */}
          <button
            className="settings-menu-item"
            onClick={handleNotificationToggle}
            title={notificationEnabled ? 'Disable notifications' : 'Enable notifications'}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {notificationEnabled ? (
                <>
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                  <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                  <circle cx="18" cy="8" r="3" fill="currentColor"/>
                </>
              ) : (
                <>
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                  <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                  <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2"/>
                </>
              )}
            </svg>
            <span>Notifications</span>
            <span className={`settings-menu-item-value ${notificationEnabled ? 'enabled' : 'disabled'}`}>
              {notificationEnabled ? 'On' : 'Off'}
            </span>
          </button>

          <div className="settings-menu-divider"></div>

          {/* Logout */}
          <button
            className="settings-menu-item settings-menu-item-danger"
            onClick={handleLogout}
            title="Logout"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            <span>Logout</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default SettingsMenu;
